import React from "react";
import * as Sentry from "@sentry/react";
import styled from "styled-components";

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 40px;
  font-family: Arial, sans-serif;
  color: #343a40;
  text-align: center;
  padding: 12px;
`;

const RetryButton = styled.button`
  margin-top: 8px;
  padding: 6px 16px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  color: #343a40;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: #f8f9fa;
  }
`;

class WidgetErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <FallbackContainer>
          <span style={{ fontSize: "14px" }}>Something went wrong.</span>
          <RetryButton onClick={this.handleRetry}>Try again</RetryButton>
        </FallbackContainer>
      );
    }

    return this.props.children;
  }
}

export default WidgetErrorBoundary;
